/* analytics.js — iter98.99ds
 *
 * Lightweight, fire-and-forget event tracker. Never throws, never blocks
 * the UX, never logs noise to the console on failure. Calls land in the
 * backend's `analytics_events` collection via POST /api/analytics/events.
 *
 * Usage:
 *   import { trackEvent } from "@/lib/analytics";
 *   trackEvent("scan_visit_button_clicked", { patient_id: p.id, source: "patient_header" });
 *
 * Events the backend currently aggregates into the admin funnel:
 *   - scan_visit_button_clicked
 *   - scan_visit_booking_confirmed
 *
 * Adding a new funnel is a pure backend change — keep firing events from
 * the frontend whenever a meaningful interaction happens; the catalog grows
 * organically.
 */
import api from "@/lib/api";

export function trackEvent(eventName, properties = {}) {
    if (!eventName || typeof eventName !== "string") return;
    // Don't await — fire-and-forget. Swallow all errors so analytics can
    // never break the user's primary flow.
    api.post("/analytics/events", {
        event_name: eventName,
        properties: properties && typeof properties === "object" ? properties : {},
    }).catch(() => { /* intentionally silent */ });
}

export default trackEvent;
